var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 6H10.5C8.29086 6 6.5 7.79086 6.5 10V18C6.5 20.2091 8.29086 22 10.5 22H38.5C40.7091 22 42.5 20.2091 42.5 18V10C42.5 7.79086 40.7091 6 38.5 6Z",
    fill: "#55ABFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24H10.5C8.29086 24 6.5 25.7909 6.5 28V38C6.5 40.2091 8.29086 42 10.5 42H22.5C24.7091 42 26.5 40.2091 26.5 38V28C26.5 25.7909 24.7091 24 22.5 24Z",
    fill: "#55ABFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24H32.5C30.2909 24 28.5 25.7909 28.5 28V38C28.5 40.2091 30.2909 42 32.5 42H38.5C40.7091 42 42.5 40.2091 42.5 38V28C42.5 25.7909 40.7091 24 38.5 24Z",
    fill: "#0078EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.f392d336fc04d4c85debaa3a0cb2479c.svg";
export { ForwardRef as ReactComponent };